import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

function Header({ initialOrderType }) {
  return (
    <div className="flex items-center px-4 h-14 sticky top-0 z-auto bg-white border-1 border-solid border-gray-300">
      <Link to={`/history/${initialOrderType}`} id="detail_order_back">
        <ArrowLeftIcon className='h-6 w-6 text-gray-900 bg-white rounded-full' />
      </Link>
      <h2 className="text-base font-semibold ml-2">Detail Pesanan</h2>
    </div>
  );
}

export default Header;
